import { App as CapacitorApp } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { StorageConstants } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import { getFromStorage, isAuthenticated, saveToStorage } from '../../utils/Helper';
import ToastDefault from './Toast';
import CookieConsent from './CookieConsent';


const Layout = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleBackButton = () => {
      if (window.location.pathname === '/' || window.location.pathname === Routes?.Dashboard) {
        CapacitorApp.exitApp();
      } else {
        navigate(-1);
      }
    };

    CapacitorApp.addListener('backButton', handleBackButton);
    return () => {
      CapacitorApp.removeAllListeners();
    };
  }, [navigate]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const skipOnboarding = queryParams.get('skip_onboarding');
    const isSkipOnboarding = skipOnboarding?.toLowerCase() === 'true';

    if (isSkipOnboarding) {
      saveToStorage({ key: 'is_intro_viewed', value: true });
    }

    const introView = isSkipOnboarding || getFromStorage({ key: 'is_intro_viewed' });
    const platform = getFromStorage({ key: StorageConstants?.PLATFORM });
    if (!introView) {
      navigate(Routes?.Intro);
    }
    if (!platform) {
      const setPlatform = async () => {
        const { platform } = await Device.getInfo();
        saveToStorage({ key: StorageConstants?.PLATFORM, value: platform });
      };
      setPlatform();
    }
  }, [location.search, isAuthenticated()]);


  return (
    <>
      <div className="main-layout">
        <div className="left-side-box">
          <Outlet />
        </div>
        {/* <div className="right-side-box">
          <img src={mainLogo} alt="" />
        </div> */}
      </div>
      <ToastDefault />
      <CookieConsent />
    </>
  )
}

export default Layout